import { AnalyticsEvent } from "./analyticsEvent";
class LiveChatInteractionEvent extends AnalyticsEvent {
    public engagementName: string;
    constructor(engagementName: string) {
        super();
        this.engagementName = engagementName;
    }
}
export { LiveChatInteractionEvent }